module.exports = __webpack_public_path__ + "static/media/img-logo-gnb-blue.3c0d305e.svg";